import {DurationType, SpellDuration} from '../../generated/types';
import {durationUnitToString} from './duration-unit-to-string';

/** Длительность: «Концентрация, до 1 минуты», «мгновенное», «пока не рассеяно» */
export function toSpellDuration(durations: SpellDuration[]) {
	return durations.map((duration) => {
		switch (duration.type) {
			case DurationType.Instant:
				return 'мгновенное';
			case DurationType.Permanent:
				return duration.ends
					?.map((end) => (end === 'dispel' ? 'пока не рассеяно' : end === 'trigger' ? 'пока не сработает' : ''))
					.join(' или ');
			case DurationType.Special:
				return 'Особая';
			case DurationType.Timed: {
				let text = '';
				const upTo = duration.upTo || duration.concentration;
				if (duration.concentration) {
					text += `Концентрация, `;
				}
				if (duration.amount && duration.units) {
					text += `${upTo ? 'до ' : ''}${durationUnitToString(duration.amount, duration.units, upTo)}`;
				}

				return text;
			}
		}
	});
}
